import { apiClient } from '@/services/client/ApiClient.js';

export default {
  getAll() {
    return apiClient.get('/button-links', { useCache: true });
  }
};
